export const baseURL = 'http://www.linkxinjie.com'
